/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * At least one of userId or email is required.
 * @export
 * @interface InviteUniversalTeamMemberBody
 */
export interface InviteUniversalTeamMemberBody {
    /**
     * DevourPlay user ID to invite
     * @type {string}
     * @memberof InviteUniversalTeamMemberBody
     */
    userId?: string;
    /**
     * Email address to invite (alternative to userId)
     * @type {string}
     * @memberof InviteUniversalTeamMemberBody
     */
    email?: string;
    /**
     * Optional message from captain
     * @type {string}
     * @memberof InviteUniversalTeamMemberBody
     */
    message?: string;
}

/**
 * Check if a given object implements the InviteUniversalTeamMemberBody interface.
 */
export function instanceOfInviteUniversalTeamMemberBody(value: object): value is InviteUniversalTeamMemberBody {
    return true;
}

export function InviteUniversalTeamMemberBodyFromJSON(json: any): InviteUniversalTeamMemberBody {
    return InviteUniversalTeamMemberBodyFromJSONTyped(json, false);
}

export function InviteUniversalTeamMemberBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): InviteUniversalTeamMemberBody {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'] == null ? undefined : json['userId'],
        'email': json['email'] == null ? undefined : json['email'],
        'message': json['message'] == null ? undefined : json['message'],
    };
}

export function InviteUniversalTeamMemberBodyToJSON(json: any): InviteUniversalTeamMemberBody {
    return InviteUniversalTeamMemberBodyToJSONTyped(json, false);
}

export function InviteUniversalTeamMemberBodyToJSONTyped(value?: InviteUniversalTeamMemberBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userId': value['userId'],
        'email': value['email'],
        'message': value['message'],
    };
}

